import React, { useEffect, useState } from 'react'
import { Row, Space, Spin, Typography } from 'antd'
import CustomDrawer from '../../../components/CustomDrawer/CustomDrawer'
import ProfileAvatar from '../../candidate/components/profil-avatar'
import { BackIcon } from '../../../assets/icons/backIcon'
import UserReportsDrawerFilter from './userReportsDrawerFilter'
import { useDispatch, useSelector } from 'react-redux'
import {
    getUserByIdAllTaskLog,
    resetDrawerFilter,
} from '../store/finalReports.slice'
import ReportDrawerBody from './reportDrawerBody'

const UserReportsDrawer = ({ open, setOpen, user }) => {
    const { Text } = Typography
    const [activeTab, setActiveTab] = useState('time-log')
    const [activeKey, setActiveKey] = useState(null)
    const { reportDrawerFilterData, userTaskLogs, userReportsTaskLogLoading } =
        useSelector((state) => state.finalReportsSlice)
    const dispatch = useDispatch()
    useEffect(() => {
        if (
            !reportDrawerFilterData?.start ||
            !reportDrawerFilterData?.end ||
            !open
        )
            return

        const { projectId, ...rest } = reportDrawerFilterData

        const validProjectIds = Array.isArray(projectId)
            ? projectId
                .map((p) => p?.value)
                .filter((val) => typeof val === 'string' && val.trim() !== '')
            : []

        const cleanData = {
            ...rest,
            userId: user?._id,
            ...(validProjectIds.length > 0
                ? { projectId: validProjectIds }
                : {}),
        }
        if (activeTab == 'time-log') {

            dispatch(getUserByIdAllTaskLog(cleanData))
        }
    }, [dispatch, reportDrawerFilterData, activeTab, user?._id])

    const handleSubmit = () => { }
    return (
        <>
            {/* <Button type="primary" onClick={() => setOpen(true)}>
                Open Drawer
            </Button> */}

            <CustomDrawer
                open={open}
                onClose={() => {
                    setOpen(false)
                    dispatch(resetDrawerFilter())
                }}
                onSubmit={handleSubmit}
                showFooter={false}
                title={
                    <>
                        <Space
                            align="center"
                            style={{
                                justifyContent: 'space-between',
                                width: '100%',
                            }}
                        >
                            <Row>
                                <ProfileAvatar
                                    name={user?.name}
                                    profilePicture={user?.profilePicture}
                                    size={40}
                                />
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        marginLeft: '5px',
                                    }}
                                >
                                    <Text strong style={{ fontSize: 16 }}>
                                        {user?.name || 'User Form'}
                                    </Text>

                                    <Text
                                        type="secondary"
                                        style={{ fontSize: 12 }}
                                    >
                                        {user?.email || ''}
                                    </Text>
                                </div>
                            </Row>
                            <div
                                style={{ cursor: 'pointer' }}
                                onClick={() => setOpen(false)}
                            >
                                <BackIcon />
                            </div>
                        </Space>
                        <div style={{ marginTop: '13px' }}>
                            <UserReportsDrawerFilter user={user} />
                        </div>
                    </>
                }
                width={1000}
            >
                <Spin spinning={userReportsTaskLogLoading}>
                    <ReportDrawerBody
                        activeTab={activeTab}
                        setActiveTab={setActiveTab}
                        reportData={userTaskLogs}
                        activeKey={activeKey}
                        setActiveKey={setActiveKey}
                        user={user}
                    />
                </Spin>
            </CustomDrawer>
        </>
    )
}

export default UserReportsDrawer
